import React from 'react';
import { Auth } from '@justgiving/auth';

interface AnalyticsCookie {
  loggedOutGuid?: string;
  loggedInGuid?: string;
}

export const AuthContext = React.createContext<(Auth & AnalyticsCookie) | null>(
  null,
);
